import {useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import SelfcarePageContent from "../../components/selfcare/SelfcarePageContent.tsx";
import Icon from "../../components/selfcare/Icon.tsx";
import IconAlert from "../../components/icons/IconAlert.tsx";
import HardwareOverview from "../../components/selfcare/HardwareOverview.tsx";
import HelpArticlesInternet from "../../components/selfcare/HelpArticlesInternet.tsx";
import {ERROR_REPORT_STATUS} from "../../util/types.ts";
import {formatDate} from "../../util/formatter.ts";
import {selfcareGetErrorReportStatus} from "../../util/request.ts";
import NetworkOverview from "../../components/selfcare/NetworkOverview/NetworkOverview.tsx";
import {useCustomer} from "../../layouts/SelfcareLayout.tsx";
import Routing from "../../Routing.ts";
import {filterOnProductsThatCanSeeTheNetwork} from "../../util/helpers.ts";
import {LocationAwareLink} from "../../components/selfcare/LocationAwareLink.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";

export default function InternetPage() {
    setTitleAndMetaDescription("Internet - Mit Hiper", "Her kan du fejlmelde dit internet, samt se det udstyr der er tilknyttet dit abonnement.");

    const {customer} = useCustomer()
    const filtered_laks_products = filterOnProductsThatCanSeeTheNetwork(customer.product_instances)

    return <>
        <SelfcarePageContent className={'selfcare-page-network-overview'}>
            {filtered_laks_products.length > 0 &&
                <NetworkOverview product_instances={filtered_laks_products}/>
            }
            <ReportOffline/>
        </SelfcarePageContent>
        <hr/>
        <HardwareOverview/>
        <HelpArticlesInternet/>
    </>
}

const ReportOffline = () => {
    return (
        <div className={'selfcare-report-error'}>
            <div className={'title'}>
                <h2 className="heading heading--montserrat">
                    Driller dit internet?
                </h2>
                <p>
                    Det er vi kede af &ndash; det finder vi selvfølgelig en løsning på!
                    Tryk på knappen og vi vil hjælpe dig på rette vej.
                </p>
            </div>

            <p className={'align-center'}>
                <ReportOfflineButton/>
            </p>
        </div>
    );
}

const ReportOfflineButton = () => {
    const {customer} = useCustomer();
    const [errorReportStatus, setErrorReportStatus] = useState<ERROR_REPORT_STATUS | null>(null);
    const [onlineDate, setOnlineDate] = useState<string | null>(null);

    useEffect(() => {
        selfcareGetErrorReportStatus(customer.customer_id).then(response => {
            try {
                setErrorReportStatus(response.response.data.error_report_status);
                setOnlineDate(response.response.data.product_instance_date);
            } catch {
                setErrorReportStatus(ERROR_REPORT_STATUS.EXCEPTION);
            }
        }).catch(() => setErrorReportStatus(ERROR_REPORT_STATUS.EXCEPTION));
    }, [customer.customer_id]);

    return (
        <>
            <Link
                to={errorReportStatus === ERROR_REPORT_STATUS.ACTIVE ? Routing.Selfcare.ErrorReport : "#"}
                className={`button button--montserrat teal rounded with-icon fejlmelding-startet ${errorReportStatus !== ERROR_REPORT_STATUS.ACTIVE ? 'disabled' : ''}`}
            >
                <span className={'text'}>
                    Start fejlmelding
                </span>
                <Icon component={IconAlert}/>
            </Link>
            {errorReportStatus === ERROR_REPORT_STATUS.PENDING_MAX && (
                <div className={'warning-box'}>
                    <p>
                        Du kan ikke fejlmelde dit internet, da det ikke er aktivt endnu.
                        Vi afventer stadig datoen for, hvornår det er klar.
                    </p>
                </div>
            )}
            {errorReportStatus === ERROR_REPORT_STATUS.PENDING && (
                <div className={'warning-box'}>
                    <p>
                        Du kan ikke fejlmelde dit internet, da det ikke er aktivt endnu.
                        Dit internet er klar d. <strong>{formatDate(onlineDate ?? '', 'DD/MM-YYYY')}</strong>.
                    </p>
                </div>
            )}
            {errorReportStatus === ERROR_REPORT_STATUS.NONE && (
                <div className={'warning-box'}>
                    <p>
                        Du har ingen aktive produkter, som kan fejlmeldes.
                    </p>
                </div>
            )}
            {errorReportStatus === ERROR_REPORT_STATUS.SOFTCLOSED && (
                <div className={'warning-box'}>
                    <p>Dit internet er lukket, da du har en ubetalt regning. Dit internet åbner automatisk når vi har modtaget din betaling.</p>
                    <LocationAwareLink
                        to={Routing.Selfcare.PayBill}
                        className={'button button--montserrat white-red rounded'}
                    >
                        Betal regning
                    </LocationAwareLink>
                </div>
            )}
            {errorReportStatus === ERROR_REPORT_STATUS.EXCEPTION && (
                <div className={'warning-box'}>
                    <p>
                        Der er desværre sket en fejl.
                        Genindlæs siden eller prøv igen senere.{' '}
                        <Link to={Routing.Contact.Index} className={'link'}>Kontakt os her</Link>,{' '}
                        hvis fejlen bliver ved med at opstå.
                    </p>
                </div>
            )}
        </>
    );
};
